module.exports = __webpack_public_path__ + "media/images/admin/logo-white-a759246badca3af6f917378b24b834a6.svg";